<template lang="pug">
  b-modal(
    v-model="show",
    header-class="lmm-common-popup-header",
    :header-bg-variant="dialog.headerBgVariant",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant",
    @shown="focusIn"
    hide-footer
    no-close-on-backdrop)
    template(slot="modal-header")
      img(src="../../assets/admin_main_log.svg" style="height: 20px")
    b-container(fluid)
      div.context(v-html="$t(dialog.context.path, dialog.context.args)", :style="{'text-align': dialog.align}") {{dialog.selfUnlock}}
      div(v-if="dialog.context.path === 'login_failure_limit' && this.dialog.selfUnlock === 1" class="d-flex justify-content-center")
        b-btn.mt-3(variant="primary", :disabled="sendEmailDisabled", @click="sendEmail" ) {{$t('send_email')}}
      div.buttons
        b-btn(
          ref="close",
          size="sm",
          class="float-right",
          @click="close"
        ) {{$t('submit')}}
</template>

<script>
import _ from "lodash"
import AppState from "@/plugins/appstate"
import { resetPW } from "@/api/manage-auth"

const defaultValues = {
  size: "lg",
  title: "",
  context: "",
  headerBgVariant: "light",
  headerTextVariant: "dark",
  bodyBgVariant: "light",
  bodyTextVariant: "dark",
  footerBgVariant: "light",
  footerTextVariant: "dark",
  align: "left",
}

export default {
  name: "message-dialog",
  methods: {
    focusIn() {
      this.$refs.close.focus()
    },
    close() {
      this.show = false
    },
    sendEmail() {
      this.sendEmailDisabled = true
      let params = {
        lang_code: this.$i18n.locale,
        key: this.dialog.userId,
        type: "unlock",
      }
      resetPW(params)
        .then(resp => {
          this.sendEmailDisabled = false
          let { objects } = resp.data
          if (objects.result === "Success") {
            let params = {
              context: { path: "password_modify_mail_sent" },
            }
            this.AppState.$emit("show-message-dialog", params)
          } else {
            let params = {
              context: { path: "not_matched_user" },
            }
            this.AppState.$emit("show-message-dialog", params)
          }
        })
        .catch(err => {
          this.$log.error(err)
          this.sendEmailDisabled = false
        })
    },
  },
  created() {
    this.dialog = defaultValues
    this.AppState.$on("show-message-dialog", data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
    })
  },
  data() {
    return {
      sendEmailDisabled: false,
      show: false,
      dialog: {},
    }
  },
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>